module.exports = __webpack_public_path__ + "img/palladiumWhitegold@2x.4d3d097.jpg";